var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.section},[_c('div',{class:_vm.$style.border},[_c('icon',{class:_vm.$style.icon,attrs:{"name":"shield","width":"14","height":"14"}})],1),_c('p',{class:_vm.$style.text,domProps:{"innerHTML":_vm._s(_vm.$t('verifications.notify'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }